import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Attempt a token refresh once on 401, then retry.
let refreshing = null;
api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config;
        if (
            error.response &&
            error.response.status === 401 &&
            !original._retry &&
            !original.url.includes("/auth/")
        ) {
            original._retry = true;
            try {
                refreshing = refreshing || api.post("/auth/refresh");
                await refreshing;
                refreshing = null;
                return api(original);
            } catch (e) {
                refreshing = null;
            }
        }
        return Promise.reject(error);
    },
);
